import React from 'react';

import styles from './navigationDivider.module.scss';

export const NavigationDivider = () => <div className={styles.navDivider} />;
